import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ClippingStudioMamItem } from "app/js/src/domain/clipping-studio/clipping-studio-mam-item";
import {
  AddGfxToTimelineRequest,
  UpdateTimelineGfxParamsRequest,
} from "../panels/graphics-panel/clipping-studio-graphics-panel.component";

export interface LeftSidebarTool {
  id: string;
  label: string;
}

@Component({
  selector: "evrideo-clipping-studio-left-sidebar",
  templateUrl: "./clipping-studio-left-sidebar.component.html",
  styleUrls: ["./clipping-studio-left-sidebar.component.scss"],
})
export class ClippingStudioLeftSidebarComponent {
  @Input() activeTool = "ai";
  @Output() activeToolChange = new EventEmitter<string>();
  @Output() close = new EventEmitter<void>();
  @Output() segmentAdded = new EventEmitter<string>();
  @Output() addToTimeline = new EventEmitter<ClippingStudioMamItem>();
  @Output() addGfxToTimeline = new EventEmitter<AddGfxToTimelineRequest>();
  @Output() updateTimelineGfxParamsRequested = new EventEmitter<UpdateTimelineGfxParamsRequest>();

  readonly tools: LeftSidebarTool[] = [
    { id: "ai", label: "Find Clip" },
    { id: "media", label: "Media" },
    { id: "transcript", label: "Transcript & Subtitles" },
    { id: "graphics", label: "Graphics" },
    { id: "text", label: "Text" },
  ];

  transcriptStylePanelOpen = false;

  onClose(): void {
    this.close.emit();
  }

  setActiveTool(id: string): void {
    this.activeTool = id;
    this.activeToolChange.emit(id);
    if (id !== "transcript") {
      this.transcriptStylePanelOpen = false;
    }
  }
}
